import { Routes } from '@angular/router';
import { BbitAuthGuard, bbitWebsiteAuthRoutes } from '@bbitgmbh/website.sdk';
import { AccountComponent } from './account/account.component';
import { ProfileComponent } from './account/profile/profile.component';
import { AreasComponent } from './areas/areas.component';
import { DealerComponent } from './dealer/dealer.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { HomeComponent } from './home/home.component';
import { ImprintComponent } from './imprint/imprint.component';
import { LegalComponent } from './legal/legal.component';
import { NewsComponent } from './news/news.component';
import { NewsDetailComponent } from './news/news-detail/news-detail.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ProductDetailComponent } from './products/product-detail/product-detail.component';
import { ProductsComponent } from './products/products.component';
import { ShooterComponent } from './shooter/shooter.component';
import { CartComponent } from './shop/cart/cart.component';
import { ItemDetailComponent } from './shop/item-detail/item-detail.component';
import { ItemListComponent } from './shop/item-list/item-list.component';
import { NewProductsComponent } from './shop/new-products/new-products.component';
import { OrderResultComponent } from './shop/order-result/order-result.component';
import { PromotionsComponent } from './shop/promotions/promotions.component';
import { RedirectToPaymentComponent } from './shop/redirect-to-payment/redirect-to-payment.component';
import { ShopComponent } from './shop/shop.component';

export const appRoutes: Routes = [
  ...bbitWebsiteAuthRoutes,
  {
    path: '',
    component: HomeComponent,
  },
  { path: 'products', component: ProductsComponent },
  { path: 'products/:code', component: ProductDetailComponent },
  { path: 'news/:id', component: NewsDetailComponent },
  { path: 'news', component: NewsComponent },
  { path: 'shooter', component: ShooterComponent },
  { path: 'dealer', component: DealerComponent },
  { path: 'downloads', component: DownloadsComponent },
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [BbitAuthGuard],
    children: [
      { path: 'profile', component: ProfileComponent },
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
    ],
  },
  {
    path: 'shop',
    component: ShopComponent,
    children: [
      { path: 'item/:slug', component: ItemDetailComponent },
      { path: 'items', component: ItemListComponent },
      { path: 'order-result', component: OrderResultComponent },
      { path: 'redirect-to-payment', component: RedirectToPaymentComponent },
      { path: 'promotions', component: PromotionsComponent },
      { path: 'new-products', component: NewProductsComponent },
      { path: 'cart', component: CartComponent },
      { path: '**', redirectTo: 'items' },
    ],
  },
  { path: 'imprint', component: ImprintComponent },
  { path: 'legal', component: LegalComponent },
  { path: 'privacy', component: PrivacyComponent },
  {
    path: 'bereiche',
    component: AreasComponent,
  },

  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
